interface Props {
  width?: number | string;
  height?: number | string;
  rounded?: boolean;
  inline?: boolean;
}

/** Grey shimmer placeholder. Use generously while data loads. */
export function Skeleton({ width, height, rounded, inline }: Props) {
  return (
    <span
      aria-hidden="true"
      className="skeleton"
      style={{
        display: inline ? "inline-block" : "block",
        width: width ?? "100%",
        height: height ?? 14,
        borderRadius: rounded ? 999 : 4,
      }}
    />
  );
}

interface RowsProps {
  rows: number;
  /** Columns per row — each will be 1fr unless an array of widths supplied. */
  cols?: number | (string | number)[];
}

/** Multi-row skeleton placeholder for table-like loading. */
export function SkeletonRows({ rows, cols = 3 }: RowsProps) {
  const widths = Array.isArray(cols)
    ? cols
    : Array.from({ length: cols }, () => "1fr");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10, padding: 12 }}>
      {Array.from({ length: rows }, (_, r) => (
        <div
          key={r}
          style={{
            display: "grid",
            gridTemplateColumns: widths
              .map((w) => (typeof w === "number" ? `${w}px` : w))
              .join(" "),
            gap: 12,
            alignItems: "center",
          }}
        >
          {widths.map((_, c) => (
            <Skeleton key={c} height={14} />
          ))}
        </div>
      ))}
    </div>
  );
}
